import styled from 'styled-components';

export const Container = styled.div`
  width: 420px;
  height: 240px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 2px solid
    ${(props) =>
      props.theme.isVaultVariant
        ? props.theme.newPalette.turquoise.T400
        : props.theme.atlas.semantic.color.action.primary.default};
  border-radius: 12px;
  background-color: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newPalette.neutral.N800
      : props.theme.atlas.semantic.color.surface.inverse};
  margin: 0px 10px;
`;

export const Logo = styled.img`
  height: 64px;
  width: 64px;
`;

export const Title = styled.h3`
  font-weight: 700;
  font-size: 32px;
  color: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newPalette.neutral.N0
      : props.theme.atlas.semantic.color.type.inverse};
  margin: 10px 0px;
  font-family: ${(props) => props.theme.typography.fontFamily};
  text-align: center;
`;

export const SubTitle = styled.h4`
  font-weight: ${(props) => props.theme.typography.h4.fontWeight};
  font-size: 18px;
  line-height: 25px;
  color: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newPalette.turquoise.T400
      : props.theme.atlas.semantic.color.action.primary.default};
  text-align: center;
  margin: 0px;
  font-family: ${(props) => props.theme.typography.fontFamily};
`;
